import React from 'react';
import NotFoundImage from '../assets/images/404.svg';

const NotFound: React.FC = () => (
  <div className="not-found-page main-container">
    <div className="not-found-page__wrapper flex align-center justify-center">
      <div className="message flex column">
        <h3 className="fs30">Oops… something is wrong</h3>
        <p className="fs18">We can’t find the page that you are looking for…</p>
      </div>
      <img src={NotFoundImage} alt="Not found" />
    </div>
  </div>
);

export default NotFound;
